import { atomFamily } from "recoil";
import { LayoutWindowId } from "../Types/LayoutWindowId";
import { getDefaultVisualizationAtom } from "./Visualizations";
import { MAPOptPlotConfig } from "../Types/MAPOptPlot";
import { Analytic } from "../Types/AnalysisDetails";

export const mapOptPlotConfigsAtom = atomFamily<MAPOptPlotConfig, LayoutWindowId>({
    key: "mapoptPlotConfigs",
    default: () => ({
        ...getDefaultVisualizationAtom(),
        abpModality: "ABP_na",
        stO2Left: "StO2_1_Left_Brain",
        stO2Right: "StO2_2_Right_Brain",
        coxThreshold: 0.3,
        mapoptAlgorithm: Analytic.MAPOpt,
        enableLeft: true,
        enableRight: true
    })
})
